/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { AdminReserveSurveyMarksBody } from '../../models/admin-reserve-survey-marks-body';
import { ReserveSurveyMarksDto } from '../../models/reserve-survey-marks-dto';

export interface AdminReserveSurveyMarks$Params {
  body: AdminReserveSurveyMarksBody;
}

export function adminReserveSurveyMarks(
  http: HttpClient,
  rootUrl: string,
  params: AdminReserveSurveyMarks$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ReserveSurveyMarksDto>> {
  const rb = new RequestBuilder(rootUrl, adminReserveSurveyMarks.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReserveSurveyMarksDto>;
      }),
    );
}

adminReserveSurveyMarks.PATH = '/admin/surveyMarks/reserved';
